import { Button, Text } from 'pcln-design-system';
import React from 'react';
import analytics from '../analytics';
export const handleChooseHotelRoomButtonClick = ({
  hotelId,
  args,
  detailURL
}) => event => {
  event.stopPropagation();
  event.preventDefault();
  analytics.log(Object.assign({
    label: 'HotelSearchResult',
    hotelId: hotelId,
    message: 'HOTEL_DETAIL_LINK_CLICKED'
  }, args));
  window.open(detailURL, '_blank');
};
export const ChooseHotelRoomButton = props => {
  const {
    buttonProps,
    buttonCopy,
    detailURL,
    hotelId,
    args
  } = props;
  return React.createElement(Button, Object.assign({}, buttonProps, {
    onClick: handleChooseHotelRoomButtonClick({
      hotelId,
      args,
      detailURL
    })
  }), React.createElement(Text, {
    bold: true,
    fontSize: 0
  }, buttonCopy));
};
ChooseHotelRoomButton.defaultProps = {
  buttonCopy: 'Choose Room',
  buttonProps: {},
  detailURL: '',
  hotelId: '',
  args: {}
};